module.exports = __webpack_public_path__ + "static/NodeJS-Iphone-7bc80122273097c18bf4735e36040498.mp4";